export default __webpack_public_path__ + "static/media/experience-text-round.02c43fb7.png";